import {Improvement, ImprovementStatic} from '@/stores/ImprovementsStore/ImprovementsStore.types';

export const improvementsStatic: ImprovementStatic[] = [
  {
    id: 'imp1',
    name: 'Спутник связи',
    description: 'Открывает доступ к исследованиям',
    requiredTotalIncomePerHour: 0,
  },
  {
    id: 'imp2',
    name: 'Межзвёздная биржа',
    description: 'Подключает корабль к главной сети торговли кристаллами',
    requiredTotalIncomePerHour: 900,
  },
  {
    id: 'imp3',
    name: 'Галактический счёт',
    description: 'Открывает доступ к исследованиям',
    requiredTotalIncomePerHour: 1500,
  },
  {
    id: 'imp4',
    name: 'Нейтронный магнит облигаций',
    description: 'Открывает доступ к исследованиям',
    requiredTotalIncomePerHour: 3000,
  },
  {
    id: 'imp5',
    name: 'Дивидендный локатор',
    description: 'Открывает доступ к исследованиям',
    requiredTotalIncomePerHour: 10000,
  },
  {
    id: 'imp15',
    name: 'Роботрейдер 2',
    description: '',
    requiredTotalIncomePerHour: 225000,
  },
  {
    id: 'imp6',
    name: 'Космическая дивидендная корова',
    description: '',
    requiredTotalIncomePerHour: 15000,
  },
  {
    id: 'imp7',
    name: 'Фондовая торпеда',
    description: '',
    requiredTotalIncomePerHour: 20000,
  },
  {
    id: 'imp8',
    name: 'Депозитный отсек',
    description: '',
    requiredTotalIncomePerHour: 115000,
  },
  {
    id: 'imp9',
    name: 'Галактический хедж-фонд',
    description: '',
    requiredTotalIncomePerHour: 115000,
  },
  {
    id: 'imp10',
    name: 'Роботрейдер',
    description: '',
    requiredTotalIncomePerHour: 115000,
  },
  {
    id: 'imp11',
    name: 'Роботрейдер 2',
    description: '',
    requiredTotalIncomePerHour: 115000,
  },
  {
    id: 'imp12',
    name: 'Роботрейдер 2',
    description: '',
    requiredTotalIncomePerHour: 115000,
  },
  {
    id: 'imp13',
    name: 'Роботрейдер 2',
    description: '',
    requiredTotalIncomePerHour: 200000,
  },
  {
    id: 'imp14',
    name: 'Роботрейдер 2',
    description: '',
    requiredTotalIncomePerHour: 215000,
  },
];

export const improvementsList: Improvement[] = [
  {
    id: 'imp1',
    currentLevel: 0,
    currentLevelIncomePerHour: 0,
    nextLevelIncomePerHour: 400,
    upgradeCost: 50,
    frozenUntil: '2023-01-01T00:00:00.000Z',
  },
  {
    id: 'imp2',
    currentLevel: 0,
    currentLevelIncomePerHour: 0,
    nextLevelIncomePerHour: 600,
    upgradeCost: 100,
    frozenUntil: '2023-01-01T00:00:00.000Z',
  },
  {
    id: 'imp3',
    currentLevel: 0,
    currentLevelIncomePerHour: 0,
    nextLevelIncomePerHour: 1000,
    upgradeCost: 150,
    frozenUntil: '2023-01-01T00:00:00.000Z',
  },
  {
    id: 'imp4',
    currentLevel: 0,
    currentLevelIncomePerHour: 0,
    nextLevelIncomePerHour: 1400,
    upgradeCost: 200,
    frozenUntil: '2023-01-01T00:00:00.000Z',
  },
  {
    id: 'imp5',
    currentLevel: 0,
    currentLevelIncomePerHour: 0,
    nextLevelIncomePerHour: 2600,
    upgradeCost: 250,
    frozenUntil: '2023-01-01T00:00:00.000Z',
  },
  {
    id: 'imp15',
    currentLevel: 0,
    currentLevelIncomePerHour: 0,
    nextLevelIncomePerHour: 4000,
    upgradeCost: 300,
    frozenUntil: '2023-01-01T00:00:00.000Z',
  },
  {
    id: 'imp6',
    currentLevel: 0,
    currentLevelIncomePerHour: 0,
    nextLevelIncomePerHour: 11000,
    upgradeCost: 350,
    frozenUntil: '2023-01-01T00:00:00.000Z',
  },
  {
    id: 'imp7',
    currentLevel: 0,
    currentLevelIncomePerHour: 0,
    nextLevelIncomePerHour: 20000,
    upgradeCost: 400,
    frozenUntil: '2023-01-01T00:00:00.000Z',
  },
  {
    id: 'imp8',
    currentLevel: 0,
    currentLevelIncomePerHour: 0,
    nextLevelIncomePerHour: 40000,
    upgradeCost: 450,
    frozenUntil: '2023-01-01T00:00:00.000Z',
  },
  {
    id: 'imp9',
    currentLevel: 0,
    currentLevelIncomePerHour: 0,
    nextLevelIncomePerHour: 60000,
    upgradeCost: 500,
    frozenUntil: '2023-01-01T00:00:00.000Z',
  },
  {
    id: 'imp10',
    currentLevel: 0,
    currentLevelIncomePerHour: 0,
    nextLevelIncomePerHour: 100000,
    upgradeCost: 550,
    frozenUntil: '2023-01-01T00:00:00.000Z',
  },
  {
    id: 'imp11',
    currentLevel: 0,
    currentLevelIncomePerHour: 0,
    nextLevelIncomePerHour: 150000,
    upgradeCost: 600,
    frozenUntil: '2023-01-01T00:00:00.000Z',
  },
  {
    id: 'imp12',
    currentLevel: 0,
    currentLevelIncomePerHour: 0,
    nextLevelIncomePerHour: 200000,
    upgradeCost: 650,
    frozenUntil: '2023-01-01T00:00:00.000Z',
  },
  {
    id: 'imp13',
    currentLevel: 0,
    currentLevelIncomePerHour: 0,
    nextLevelIncomePerHour: 400000,
    upgradeCost: 700,
    frozenUntil: '2023-01-01T00:00:00.000Z',
  },
  {
    id: 'imp14',
    currentLevel: 0,
    currentLevelIncomePerHour: 0,
    nextLevelIncomePerHour: 900000,
    upgradeCost: 750,
    frozenUntil: '2023-01-01T00:00:00.000Z',
  },
];
